import './dorsey/style';
import FormStructure from './dorsey/form_structure';

export default FormStructure;